var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 12,
    fill: "#FF7A00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.189 17.5174L22.2218 16.9408L20.4483 13.3455C20.3999 13.2471 20.3202 13.1674 20.2218 13.119C19.9749 12.9971 19.6749 13.0986 19.5515 13.3455L17.778 16.9408L13.8108 17.5174C13.7015 17.533 13.6015 17.5846 13.5249 17.6627C13.4323 17.7578 13.3813 17.8858 13.3831 18.0185C13.3849 18.1513 13.4392 18.2779 13.5343 18.3705L16.4046 21.169L15.7265 25.1205C15.7106 25.2124 15.7207 25.307 15.7558 25.3934C15.7909 25.4798 15.8495 25.5547 15.925 25.6095C16.0005 25.6644 16.0898 25.6969 16.1829 25.7036C16.2759 25.7102 16.369 25.6906 16.4515 25.6471L19.9999 23.7815L23.5483 25.6471C23.6452 25.6986 23.7577 25.7158 23.8655 25.6971C24.1374 25.6502 24.3202 25.3924 24.2733 25.1205L23.5952 21.169L26.4655 18.3705C26.5437 18.294 26.5952 18.194 26.6108 18.0846C26.653 17.8111 26.4624 17.558 26.189 17.5174Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarPlaceholder);
export default __webpack_public_path__ + "static/media/avatar-placeholder.4c4fd3a833a473979c0c57834574e32b.svg";
export { ForwardRef as ReactComponent };